import type { ApiUserSavedSearch, SearchParams, UserSavedSearch } from "@/modules/jobAds/client/api/types"

import { SEARCH_ENGINE_VERSIONS } from "@/modules/jobAds/client/constants"

export const computeUserSavedSearches = (apiUserSavedSearches?: ApiUserSavedSearch[]): UserSavedSearch[] => {
  return (
    apiUserSavedSearches?.flatMap(savedSearch => {
      const searchParams = JSON.parse(savedSearch.attributes) as SearchParams

      const searchEngineVersion = searchParams?.searchEngineVersion
      const hasEsSavedSearchInAlgolia =
        !searchEngineVersion || searchEngineVersion === SEARCH_ENGINE_VERSIONS.ELASTIC_SEARCH

      if (hasEsSavedSearchInAlgolia) {
        return []
      }

      return {
        id: savedSearch.id,
        lastSearchTime: savedSearch.lastSearchTime,
        searchParams,
        type: savedSearch.type as UserSavedSearch["type"],
      }
    }) || []
  )
}
